import { Icon } from "@iconify/react";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getAllOrders } from "../../../../../api/order";
import AppLayout from "../../../../../layout/DashboardLayout";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import { transactionSelector } from "../../../../../redux/slices/transactionSlice";
import StoreDetailsTab from "./components/StoreDetailsTab";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export default function StoreDetails() {
  const params = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const { orderInfo, disputeInfo, isLoading } = useSelector(orderSelector);
  const { transactions } = useSelector(transactionSelector);

  const dispatch = useDispatch();
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    dispatch(getAllOrders({ page: 0, size: 50, storeId: params.id }));
 
  }, [dispatch, params.id]);


  return (
    <AppLayout>
      <div style={{ display: "flex"}}>
        <div onClick={()=>navigate(-1)}>
          <ArrowBackIosIcon sx={{
              fontSize: "18px",
              color: "#9d9d9d",
              cursor: "pointer",
              marginTop: "9.2px"
            }}
          />
        </div>
        <div>
          <h4>Store Details</h4>
          <div style={{display:"flex", alignItems:'center'}}>
            <Icon icon="maki:warehouse" width="20" height="20" style={{color:"#8D40FF"}}/>
          <h6 style={{ fontWeight: 500, marginLeft:'10px' }}>
            {orderInfo?.orders?.length > 0 ? orderInfo?.orders[0]?.store_name:"N/A"}
          </h6>
          </div>
        </div>
      </div>
      <StoreDetailsTab
        value={value}
        setValue={setValue}
        isLoading={isLoading}
        storeId={params.id}
        orders={orderInfo?.orders}
        totalOrders={orderInfo?.totalOrders}
        disputes={disputeInfo?.disputes}
        totalDisputes={orderInfo?.totalDisputes}
        transactions={transactions?.transactions}
        totalTransactions={orderInfo?.totalTransactions}
      />
    </AppLayout>
  );
}
